"use client";

import { CacheProvider } from "@chakra-ui/next-js";
import { ChakraProvider } from "@chakra-ui/react";
import customTheme from "../styles/theme";
import { RecoilRoot } from "recoil";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RoleProvider } from "@/utils/RoleContext";
import { LoginProvider } from "@/components/login/LoginContext";
import { SearchProvider } from "@/components/navbar/SearchContext";

interface IChakraProps {
  children: React.ReactNode;
}

export const Providers = ({ children }: IChakraProps) => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <CacheProvider>
          <RoleProvider>
            <LoginProvider>
              <SearchProvider>
                <ChakraProvider theme={customTheme}>
                  {children}
                  <ReactQueryDevtools initialIsOpen={false} />
                </ChakraProvider>
              </SearchProvider>
            </LoginProvider>
          </RoleProvider>
        </CacheProvider>
      </RecoilRoot>
    </QueryClientProvider>
  );
};
